import "../School/Schools.css";

export const InvoicePaymentCards = ({ stats }) => {
    const totalPayments = stats?.total || null;
    const totalPaid = stats?.paid || null;
    const totalUnpaid = stats?.pending || null;

    const statsNew = [
        {
            label: "Total Payments",
            value: totalPayments,
            icon: "fa-graduation-cap",
            colorClass: "schools-stat-card-purple",
            iconClass: "schools-stat-icon-blue", // Blue icon bg in purple card
        },
        {
            label: "Paid Payments",
            value: totalPaid,
            icon: "fa-user",
            colorClass: "schools-stat-card-green",
            iconClass: "schools-stat-icon-blue",
        },
        {
            label: "Unpaid Payments",
            value: totalUnpaid,
            icon: "fa-flag",
            colorClass: "schools-stat-card-orange",
            iconClass: "schools-stat-icon-blue",
        },
       
    ];

    return (
        <div className="row mb-4">
            {statsNew.map((stat, index) => (
                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 mb-3" key={index}>
                    <div className={`schools-stat-card ${stat.colorClass}`}>
                        <div>
                            <p className="schools-stat-label mb-0">{stat.label}: </p>
                        </div>
                        <div className="schools-stat-content">
                            
                            <p className="schools-stat-value">{stat.value}</p>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};
